export default __webpack_public_path__ + "static/media/4188.0f3d20da.png";